import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './tailwind.css';  // Import tailwind.css instead of index.css
import './styles/portfolio.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
